import Vue from 'vue'
import {eventHub} from '@/main'

const state = {
    isAppUpToDate: null,
    isShowingUpgradePlanPopup: false,
    isShowingSomethingWentWrongPopup: false,
    // richPrompt -> @/tools/richPrompt
    showRichPrompt: false,
    richPromptServerInfo: null,
    richPromptStatuses: [
        {
            id: 0,
            label: 'success'
        },
        {
            id: 1,
            label: 'info'
        },
        {
            id: 2,
            label: 'error'
        },
    ]
}

const getters = {
    getisAppUpToDate: (state) => state.isAppUpToDate,
    getIsShowingUpgradePlanPopup: (state) => state.isShowingUpgradePlanPopup,
    getIsShowingSomethingWentWrongPopup: (state) => state.isShowingSomethingWentWrongPopup,
    // richPrompt
    getShowRichPrompt: (state) => state.showRichPrompt,
    getRichPromptServerInfo: (state) => state.richPromptServerInfo,
    getRichPromptStatuses: (state) => state.richPromptStatuses,
}

const actions = {
    checkAppVersion: ({ state }, options) => {
        var version = process.env.CURRENT_VERSION
        // options:
        // forceRefresh = bool
        options = options? options : {}

        // console.log('checkAppVersion (current)', version);
        return axios.get('/api/Configurations/GetConfiguration', {
            params:{
                configKey: 'App.Supplier.Version',
            }
        }).then(response => {
            if(response.status && response.status == 200){
                // console.log('Local version: '+version+' Remote version: '+response.data);
                if(response.data !== version){
                    state.isAppUpToDate = false
                    // console.log('You need to update');
                    if(options.forceRefresh){
                        // location.reload(true)
                    }
                } else {
                    state.isAppUpToDate = true
                    // console.log('You are running the latest version');
                }
            }
        })
    },

    showUpgradePlanPopup: ({ commit }, payload) => {
        commit('TOGGLE_UPGRADE_PLAN_POPUP', payload)
    },

    showSomethingWentWrongPopup: ({ commit }, payload) => {
        commit('TOGGLE_SOMETHING_WENT_WRONG_POPUP', payload)
    },

    // richPrompt
    displayRichPrompt: ({state}) => {
        state.showRichPrompt = true
    },

    hideRichPrompt: ({state}) => {
        state.showRichPrompt = false
    },

    richPrompt: function ({state, dispatch}, serverInfo) {
        state.richPromptServerInfo = serverInfo
        dispatch('displayRichPrompt')

        var promise = new Promise(function(resolve, reject) {
            eventHub.$on('responeRichPrompt', (responseType) => {
                switch (responseType) {
                    case "default_ok":
                        resolve(responseType);
                        dispatch('hideRichPrompt')
                        break;
                    case "default_cancel":
                        reject(responseType);
                        dispatch('hideRichPrompt')
                        break;
                    default:

                }
            });
        });

        return promise
    }

}

const mutations = {
    TOGGLE_UPGRADE_PLAN_POPUP: (state, payload) => {
        state.isShowingUpgradePlanPopup = payload;
    },
    TOGGLE_SOMETHING_WENT_WRONG_POPUP: (state, payload) => {
        state.isShowingSomethingWentWrongPopup = payload;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js